import { render, staticRenderFns } from "./combinedDataEdit.vue?vue&type=template&id=034dbfcc&scoped=true"
import script from "./combinedDataEdit.vue?vue&type=script&lang=js"
export * from "./combinedDataEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "034dbfcc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yanchenrong/code/youxiang/muying/mall-super-admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('034dbfcc')) {
      api.createRecord('034dbfcc', component.options)
    } else {
      api.reload('034dbfcc', component.options)
    }
    module.hot.accept("./combinedDataEdit.vue?vue&type=template&id=034dbfcc&scoped=true", function () {
      api.rerender('034dbfcc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/content/resource/combinedDataEdit.vue"
export default component.exports